module.exports = __webpack_public_path__ + "/img/BGA-Labeled-9tGGWv.svg";